"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _underscore = require("underscore");
var _ = require("../..");
var _helpers = require("../../helpers");
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var _useVideoThumbnail = require("../../hooks/useVideoThumbnail");
var _TranscodingState = require("../TranscodingState");
var _DisabledCameraBody = _interopRequireDefault(require("./DisabledCameraBody"));
var _UnassignedPresenterListItem = _interopRequireDefault(require("./UnassignedPresenterListItem"));
var _InitializingBody = _interopRequireDefault(require("./InitializingBody"));
var _CameraOffState = require("../CameraOffState");
var _hooks = require("../../hooks");
var _reactRedux = require("react-redux");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SourceMediaBody = function SourceMediaBody(_ref) {
  var value = _ref.value,
    type = _ref.type,
    _ref$isCameraOn = _ref.isCameraOn,
    isCameraOn = _ref$isCameraOn === void 0 ? true : _ref$isCameraOn,
    thumbnail = _ref.thumbnail,
    onThumbnailReady = _ref.onThumbnailReady,
    _ref$isInitializing = _ref.isInitializing,
    isInitializing = _ref$isInitializing === void 0 ? false : _ref$isInitializing,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    title = _ref.title,
    photo = _ref.photo,
    onSourceDeleted = _ref.onSourceDeleted,
    AttendeeTileComponent = _ref.AttendeeTileComponent,
    isDirectorSource = _ref.isDirectorSource;
  var isCameraOffStateEnabled = (0, _helpers.shouldHaveFeature)('branding.cameraOffState');
  var broadcastSettingHasBranding = (0, _reactRedux.useSelector)(function (state) {
    var _state$broadcastSetti;
    return (_state$broadcastSetti = state.broadcastSettings) === null || _state$broadcastSetti === void 0 ? void 0 : _state$broadcastSetti.branding;
  });
  var videoRef = (0, _react.useRef)(null);
  var isUnassigned = value === _broadcastSourceHelper.UNASSIGNED;
  var transcodingStatus = (0, _underscore.isObject)(value) && value.transcodingStatus;
  var isProcessingVideo = transcodingStatus && transcodingStatus !== 'success';
  var showTranscodingStatus = (0, _react.useMemo)(function () {
    return type === _.VIDEO_FILE && transcodingStatus;
  }, [type, transcodingStatus]);
  (0, _useVideoThumbnail.useVideoThumbnail)({
    videoRef: videoRef,
    thumbnail: thumbnail,
    onThumbnailReady: onThumbnailReady,
    type: type,
    isProcessingVideo: isProcessingVideo
  });
  var isStudioLite = (0, _hooks.useStudioLiteContext)();

  /** When source is in an initializing state */
  if (isInitializing && value !== _broadcastSourceHelper.UNASSIGNED) {
    return /*#__PURE__*/_react["default"].createElement(_InitializingBody["default"], {
      type: type
    });
  }

  /** Show UI when the source is unassigned */
  if (isUnassigned) {
    return /*#__PURE__*/_react["default"].createElement(_UnassignedPresenterListItem["default"], {
      type: type
    });
  }

  /** UI when camera is disabled for presenter */
  if (!isCameraOn) {
    var params = new URLSearchParams(window.location.search);
    var isBrandingEnabled = params.get('branding');
    if (isCameraOffStateEnabled && isStudioLite && (broadcastSettingHasBranding || isBrandingEnabled)) {
      var obj = _objectSpread(_objectSpread({}, (0, _.getSourceFirstNameLastName)(title)), {}, {
        photo: photo
      });
      return /*#__PURE__*/_react["default"].createElement(_CameraOffState.CameraOffState, {
        user: obj,
        height: '110px',
        width: '196px'
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement(_DisabledCameraBody["default"], {
        isUnassigned: isUnassigned
      });
    }
  }

  /** show transcoding state when video file */
  if (showTranscodingStatus && isProcessingVideo) {
    return /*#__PURE__*/_react["default"].createElement(_TranscodingState.TranscodingState, {
      status: value && value.transcodingStatus,
      onSourceDeleted: onSourceDeleted
    });
  }
  var videoNode;
  if ([_.CAMERA_PRESENTER, _.SCREEN_PRESENTER].includes(type)) {
    videoNode = /*#__PURE__*/_react["default"].createElement(AttendeeTileComponent, {
      attendeeId: value,
      attendeeTiles: attendeeTiles,
      meetingSession: meetingSession,
      isCameraOn: isCameraOn,
      onThumbnailReady: onThumbnailReady,
      isLocalAttendee: isDirectorSource
    });
  } else {
    var url = typeof value === 'string' ? value : value.url;
    videoNode = thumbnail ? /*#__PURE__*/_react["default"].createElement("img", {
      src: thumbnail,
      crossOrigin: "anonymous",
      alt: "Your browser does not support the thumbnail of this video content."
    }) : /*#__PURE__*/_react["default"].createElement("video", {
      ref: videoRef,
      src: url,
      controls: false,
      preload: "metadata",
      crossOrigin: "anonymous"
    }, "Your browser does not support the video file");
  }
  return videoNode;
};
SourceMediaBody.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  type: _propTypes["default"].string,
  hidden: _propTypes["default"].bool,
  live: _propTypes["default"].bool,
  isCameraOn: _propTypes["default"].bool,
  thumbnail: _propTypes["default"].string,
  onThumbnailReady: _propTypes["default"].func,
  isInitializing: _propTypes["default"].bool,
  attendeeTiles: _propTypes["default"].object,
  meetingSession: _propTypes["default"].object,
  title: _propTypes["default"].string,
  photo: _propTypes["default"].string,
  onSourceDeleted: _propTypes["default"].func,
  AttendeeTileComponent: _propTypes["default"].elementType,
  isDirectorSource: _propTypes["default"].bool
};
var _default = exports["default"] = SourceMediaBody;